import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { App } from 'antd';
import type { RootState, AppDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAppContext = () => App.useApp();
